import { ComponentProps } from 'react'

import { joinStyles } from 'app/utils/theme'

import { ColorDivider } from 'app/types/ui/divider'
import * as styles from './index.css'

type DividerProperties = ComponentProps<'hr'> & {
    className?: string
    color: ColorDivider
}

export const Divider = ({
    className,
    color = 'grey',
    ...properties
}: Readonly<DividerProperties>): JSX.Element => {
    return (
        <hr
            className={joinStyles(styles.base, styles.color[color], className)}
            {...properties}
        />
    )
}
